import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { useState } from 'react';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { useSelector } from 'react-redux';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { formatDate } from '../../../../../../utils/date';
import './FloatingDate.css';

dayjs.extend(utc);
dayjs.extend(timezone);

const FloatingDate = ({ id, value, onSave, name, recordId, disabled, ...rest }) => {
  const [inputValue, setInputValue] = useState(value ?? null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState();
  const timezone = useSelector((state) => state.tenant?.timezone || 'Australia/Victoria');

  const handleClose = (evt) => {
    evt?.stopPropagation();
    setOpen(false);
  };

  const handleSave = async (newValue) => {
    try {
      setOpen(false);
      setInputValue(newValue);

      onSave({ name, value: newValue, recordId });
    } catch (error) {}
  };

  const handleClick = (newPlacement) => (event) => {
    event.preventDefault();
    setAnchorEl(event?.currentTarget);
    setOpen(true);
    setPlacement(newPlacement);
  };

  return (
  <ClickAwayListener onClickAway={handleClose}>
      <Box
        className={`floating-date ${disabled ? 'floating-date-disabled' : ''}`}
        id={id}
        {...rest}
        onClick={disabled ? undefined : handleClick('bottom')}
        style={{
          position: 'relative'
        }}
      >
        <span className={`text-medium floating-date__text ${open ? 'floating-date__text--active' : ''}`}>
          {inputValue ? formatDate(inputValue, timezone, 'DD/MMM/YYYY') : 'DD/MMM/YYYY'}
        </span>
        <Box sx={{ position: 'relative' }}>
          <Popper className='marking-menu' open={open} anchorEl={anchorEl} placement={placement} transition>
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <Paper>
                  <div className='marking-menu__content' style={{ maxHeight: '340px' }}>
                    <div onClick={(event) => event.stopPropagation()}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <StaticDatePicker
                          sx={{
                            '.MuiPickersToolbar-root': {
                              color: '#fff',
                              borderRadius: '2px',
                              borderWidth: '1px',
                              borderColor: 'rgb(50, 102, 139)',
                              border: '1px solid',
                              backgroundColor: 'rgb(50, 102, 139)'
                            }
                          }}
                          id={`date-marking-${recordId}`}
                          autoFocus={true}
                          name='value'
                          value={inputValue ? dayjs(inputValue).tz(timezone) : null}
                          onChange={(selectedDate) => {
                            const selectedDateWithZeroTime = dayjs(selectedDate).startOf('day'); // Set time to 00:00:00
                            const utcDate = selectedDateWithZeroTime.tz(timezone).utc();

                            handleSave(utcDate.toISOString());
                          }}
                          format='dd/MMM/yyyy'
                          displayStaticWrapperAs='desktop'
                          showToolbar={false}
                          autoComplete='false'
                          fullWidth
                          timezone={timezone}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </Paper>
              </Fade>
            )}
          </Popper>
        </Box>
      </Box>
    </ClickAwayListener>
  );
};

export default FloatingDate;
